import { render } from "./3TeamPromo.vue?vue&type=template&id=42793f29&scoped=true"
import script from "./3TeamPromo.vue?vue&type=script&lang=js"
export * from "./3TeamPromo.vue?vue&type=script&lang=js"

import "./3TeamPromo.vue?vue&type=style&index=0&id=42793f29&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42793f29"]])

export default __exports__